module.exports = __webpack_public_path__ + "static/media/MomentosBravectoCard1.1d3f2af2.webp";